<template>
  <scrollable-container>
    <placeholder
      v-if="isTableAwaiting"
      :text="text"
      @buttonClick="buildReport"
    />
    <loader v-if="isTableLoading" />
    <div v-if="isTableReady">
      <table-files
        v-for="(data, index) in tableData"
        :key="index"
        :data="data"
        :index="index"
        @setData="setData"
      />
    </div>
    <div
      v-else-if="isTableNoData"
      :class="$style.emptyResult"
    >
      {{ $t('reports.noDataForSpecifiedPeriod') }}
    </div>
  </scrollable-container>
</template>

<script>
  import ScrollableContainer from '@/components/common/blocks/scrollable-container.vue';
  import Placeholder from '@/components/common/blocks/report-placeholder.vue';
  import Loader from '@/components/common/blocks/loader.vue';
  import { getFileUpload } from '@/api/methods/reports/users/index';
  import { REPORT_ENUM } from '@/assets/scripts/reportEnum';
  import TableFiles from './table-files.vue';

  export default {
    components: {
      ScrollableContainer,
      Placeholder,
      Loader,
      TableFiles,
    },
    data() {
      return {
        name: this.$t('navigation.reports.userWork.files.name'),
        tableData: [],
        computersArray: [],
        text: this.$t('reports.pressButtonToGenerateReport'),
      };
    },
    computed: {
      isTableReady() {
        return this.$store.getters['report/getStateTable'] === REPORT_ENUM.TABLE_READY;
      },
      isTableAwaiting() {
        return this.$store.getters['report/getStateTable'] === REPORT_ENUM.REQUEST_AWAITING;
      },
      isTableLoading() {
        return this.$store.getters['report/getStateTable'] === REPORT_ENUM.TABLE_LOADING;
      },
      isTableNoData() {
        return this.$store.getters['report/getStateTable'] === REPORT_ENUM.TABLE_NO_DATA;
      },
      dateRange() {
        return this.$store.getters['filters/formattedDateRange'];
      },
      checkedComputers() {
        return this.$store.getters['pageSpecificData/checkedComputersList'];
      },
      computersTree() {
        return this.$store.getters['pageSpecificData/computersTree'];
      },
    },
    watch: {
      dateRange(oldValue, newValue) {
        if (
          oldValue.dateFrom.toString() !== newValue.dateFrom.toString() ||
          oldValue.dateTo.toString() !== newValue.dateTo.toString()
        ) {
          this.$store.commit('report/setStateTable', REPORT_ENUM.REQUEST_AWAITING);
          this.tableData = [];
          this.setData();
        }
      },
      checkedComputers(oldArray, newArray) {
        if (oldArray !== newArray) {
          this.$store.commit('report/setStateTable', REPORT_ENUM.REQUEST_AWAITING);
          this.tableData = [];
          this.setData();
        }
      },
    },
    mounted() {
      this.$store.commit('report/setStateTable', REPORT_ENUM.REQUEST_AWAITING);
    },
    methods: {
      getCheckedComputersFromTree(node) {
        if (node.type === 'computer' && node.checked) {
          this.computersArray.push(node);
        }
        if (node.type === 'folder') {
          node.children.forEach((child) => this.getCheckedComputersFromTree(child));
        }
      },
      setData() {
        this.$store.commit('exportData/setFiles', { name: this.name, data: this.tableData });
      },
      async buildReport() {
        this.$store.commit('report/setStateTable', REPORT_ENUM.TABLE_LOADING);
        this.tableData = [];
        this.computersArray = [];

        if (this.computersTree) {
          this.computersTree.forEach((node) => this.getCheckedComputersFromTree(node));
        }
        if (this.dateRange.dateFrom && this.dateRange.dateTo && this.computersArray) {
          const { data } = await getFileUpload(
            this.computersArray,
            this.dateRange.dateFrom,
            this.dateRange.dateTo,
            this.$i18n.locale,
          );
          if (data.success) {
            this.tableData = data.result;
            if (this.tableData.length) {
              this.$store.commit('report/setStateTable', REPORT_ENUM.TABLE_READY);
              this.setData();
            } else {
              this.$store.commit('report/setStateTable', REPORT_ENUM.TABLE_NO_DATA);
            }
          } else {
            this.$store.commit('report/setStateTable', REPORT_ENUM.REQUEST_AWAITING);
          }
        }
      },
    },
  };
</script>

<style lang="scss" module>
  .emptyResult {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
</style>
